define([
    "angular",
    "../entityDTO/entityDTO"
], function (angular) {
    "use strict";

    return angular.module("nlgDualListModule", ["entityDTOModule"]);
});